import React from 'react';
import FullscreenShareButtons from './fullscreenShareButtons.js';

class FullscreenShareScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  onScroll(e) {
    e.stopPropagation();
  }

  preventScroll(el) {
    el.addEventListener('scroll', this.onScroll.bind(this))
  }

  render() {
    let curItem = this.props.current.item;
    var share = <FullscreenShareButtons item={this.props.current.item} />

    return (
      <div
        ref={element => {
          if (element) {
          this.preventScroll(element);
          }
        }}
        className={"fullscreen-share-screen" + ((this.props.showShareScreen == true) ? '' : ' closed')}
        style={{ textAlign: this.props.styleParams.galleryAlignExpand }}>
        {share}
      </div>
    );
  }
}

export default FullscreenShareScreen;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenShareScreen.js